import { Common } from "../../../common/src";
import { VerificationPointColumn } from "../config/componentsConfig";

/**
 * QU3DW-1340 — 検証点精度(dx/dy/dz)計算ロジックの単一ソース。
 *
 * 従来 HelmContext.tsx 内に散らばっていた計算処理には2つの不具合があった:
 *   (a) verification(null, ...) が「全件再計算」のつもりで呼ばれても、
 *       `r.id === id` の比較が id=null では常に false になり何も計算しない。
 *   (b) autoMapCoordinate が複数点をまとめて保存する際、1つの debounce を
 *       ループ内で使い回していたため、最後の1件しか実際には保存されない。
 *
 * このクラスは「どの行を計算対象にするか」「dx/dy/dzをどう計算するか」を
 * axios や React state から切り離し、純粋関数として単体テスト可能にする。
 */
export default class VerificationCalc {
  /**
   * 誤差(dx/dy/dz)を計算できる行だけを対象に更新用ペイロードを返す。
   * - correspondingPointId が未設定(空文字含む)の行 → 対象外(まだGCP点に紐付いていない)
   * - id === "new" の行(サーバー未登録の仮行) → 対象外
   * 対象が0件なら空配列を返す — 呼び出し側はこの場合PUTを送らないこと(D-2: 空の一覧に0.000を出さない)。
   */
  static computeErrors(
    points: VerificationPointColumn[]
  ): Common.PointVerificationForUpdate[] {
    return points
      .filter((p) => !!p.correspondingPointId && p.id !== "new")
      .map((p) => ({
        id: p.id,
        dx: p.trueX - p.x,
        dy: p.trueY - p.y,
        dz: p.trueZ - p.z,
      }));
  }
}
